module.exports = __webpack_public_path__ + "img/2025-04-12a_3.1ba1d14b.jpg";